var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "infinite-scroll",
          rawName: "v-infinite-scroll",
          value: _vm.getDemandList,
          expression: "getDemandList",
        },
      ],
      staticClass: "container-fluid infinite-list",
      attrs: {
        "infinite-scroll-immediate": "false",
        "infinite-scroll-disabled": "disabled",
      },
    },
    [
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("申請日期")]),
                  _c("el-date-picker", {
                    staticClass: "w-100",
                    attrs: {
                      type: "daterange",
                      "range-separator": "~",
                      "start-placeholder": "yyyy-MM-dd",
                      "end-placeholder": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.applyDateRange,
                      callback: function ($$v) {
                        _vm.applyDateRange = $$v
                      },
                      expression: "applyDateRange",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v(_vm._s(_vm.i18n("Basic.DemandNo"))),
                  ]),
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "請輸入關鍵字" },
                    model: {
                      value: _vm.searchCondition.ManpowerDemandNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "ManpowerDemandNo", $$v)
                      },
                      expression: "searchCondition.ManpowerDemandNo",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("需求單名稱")]),
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "請輸入關鍵字" },
                    model: {
                      value: _vm.searchCondition.ManpowerDemandName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "ManpowerDemandName", $$v)
                      },
                      expression: "searchCondition.ManpowerDemandName",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v(_vm._s(_vm.i18n("Position.PositionName"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.searchCondition.PositionCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchCondition, "PositionCode", $$v)
                        },
                        expression: "searchCondition.PositionCode",
                      },
                    },
                    _vm._l(_vm.positionOptions, function (position) {
                      return _c("el-option", {
                        key: position.Code,
                        attrs: { label: position.Name, value: position.Code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v(_vm._s(_vm.i18n("Basic.ApplyDepartment"))),
                  ]),
                  _c("treeselect", {
                    attrs: {
                      options: _vm.departmentOptions,
                      searchable: true,
                      "show-count": true,
                      "default-expand-level": 1,
                      placeholder: "請選擇",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "option-label",
                        fn: function ({
                          node,
                          shouldShowCount,
                          count,
                          labelClassName,
                          countClassName,
                        }) {
                          return _c(
                            "label",
                            { class: labelClassName, attrs: { for: "" } },
                            [
                              _vm._v(" " + _vm._s(node.label) + " "),
                              shouldShowCount
                                ? _c("span", { class: countClassName }, [
                                    _vm._v(" (" + _vm._s(count) + ") "),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        },
                      },
                    ]),
                    model: {
                      value: _vm.searchCondition.demandDepartmentGuid,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchCondition,
                          "demandDepartmentGuid",
                          $$v
                        )
                      },
                      expression: "searchCondition.demandDepartmentGuid",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("申請人")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.searchCondition.ApplicantGuid,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchCondition, "ApplicantGuid", $$v)
                        },
                        expression: "searchCondition.ApplicantGuid",
                      },
                    },
                    _vm._l(_vm.employeeOptions, function (employee) {
                      return _c("el-option", {
                        key: employee.Guid,
                        attrs: { label: employee.Name, value: employee.Guid },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("需求單狀態")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: { clearable: "", placeholder: "請選擇" },
                      model: {
                        value: _vm.searchCondition.ManpowerDemandStatus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.searchCondition,
                            "ManpowerDemandStatus",
                            $$v
                          )
                        },
                        expression: "searchCondition.ManpowerDemandStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (status) {
                      return _c("el-option", {
                        key: status.Key,
                        attrs: { label: status.Value, value: status.Key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-search",
                  staticStyle: { "margin-top": "30px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      ;(_vm.currentPage = 1),
                        (_vm.personList = []),
                        (_vm.totalDemand = 0),
                        _vm.getDemandList()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.demandList.length > 0
        ? _c("div", { staticClass: "tool-list" }, [
            _c("div", { staticClass: "tool-list-about-card" }, [
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "block" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "block"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "grid-outline" },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "list" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "list"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "list-outline" },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "demand-card-list",
          class: {
            "list-style": _vm.gridStyle === "list",
            "block-style": _vm.gridStyle === "block",
          },
        },
        _vm._l(_vm.demandList, function (demand) {
          return _c(
            "div",
            { key: demand.Guid, staticClass: "demand-card infinite-list-item" },
            [
              _c("DemandCard", {
                ref: "demandCard",
                refInFor: true,
                attrs: { category: "review", data: demand, showCheckbox: true },
                on: { updateSelectDemand: _vm.updateSelectDemand },
              }),
            ],
            1
          )
        }),
        0
      ),
      _c("ActionBar", {
        attrs: {
          show: _vm.showActionBar,
          cardType: "demandCard",
          cardStatus: _vm.cardStatus,
          selectedCardList: _vm.chooseDemandList,
        },
        on: {
          showActionBar: function ($event) {
            _vm.showActionBar = !_vm.showActionBar
          },
          selectAllCards: _vm.selectAllCards,
          clearSelectCard: _vm.clearSelectCard,
        },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function ({ props }) {
              return [
                props === "Pending"
                  ? _c(
                      "button",
                      {
                        staticClass: "action-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.openActionModal({ action: "Approved" })
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "radio-button-off-outline",
                            fill: "#FFF",
                          },
                        }),
                        _c("span", [_vm._v("同意")]),
                      ],
                      1
                    )
                  : _vm._e(),
                props === "Pending"
                  ? _c(
                      "button",
                      {
                        staticClass: "action-btn",
                        staticStyle: { "background-color": "red" },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.openActionModal({ action: "Rejected" })
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: { name: "close-outline", fill: "#FFF" },
                        }),
                        _c("span", [_vm._v("否決")]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "actionModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _vm.changeStatus === "Approved"
                  ? _c("span", [_vm._v("同意")])
                  : _c("span", [_vm._v("否決")]),
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _vm.changeStatus === "Approved"
                  ? _c("span", [_vm._v("確認同意?")])
                  : _c("span", [_vm._v("確認否決?")]),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 取消 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.changeDemandStatus },
                  },
                  [_vm._v(" 確認 ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c("DemandDetailModal"),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }